import classnames from 'classnames';
import { FiSearch, FiX } from 'react-icons/fi';

import style from '../style.module.scss';
import type { SearchSuggestion } from '../interface';

interface MapSearchBarProps {
    searchValue: string;
    isSearchLoading: boolean;
    showSearchSuggestions: boolean;
    searchSuggestions: SearchSuggestion[];
    highlightedSuggestionIndex: number;
    onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onSearchFocus: () => void;
    onSearchBlur: () => void;
    onSearchKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onResetSearch: () => void;
    onSuggestionMouseEnter: (index: number) => void;
    onSuggestionSelect: (suggestion: SearchSuggestion) => void;
    suggestionRef: (index: number, element: HTMLButtonElement | null) => void;
}

const MapSearchBar = ({
    searchValue,
    isSearchLoading,
    showSearchSuggestions,
    searchSuggestions,
    highlightedSuggestionIndex,
    onSearchChange,
    onSearchFocus,
    onSearchBlur,
    onSearchKeyDown,
    onResetSearch,
    onSuggestionMouseEnter,
    onSuggestionSelect,
    suggestionRef,
}: MapSearchBarProps) => {
    return (
        <div className={style.mapSearch}>
            <input
                className={style.searchInput}
                type="text"
                value={searchValue}
                placeholder="Caută după numele zonei, cod poștal, oraș"
                onChange={onSearchChange}
                onFocus={onSearchFocus}
                onBlur={onSearchBlur}
                onKeyDown={onSearchKeyDown}
            />
            {searchValue ? (
                <button className={style.searchControl} type="button" onClick={onResetSearch} aria-label="Resetează căutarea">
                    <FiX />
                </button>
            ) : (
                <span className={style.searchControl} aria-hidden="true">
                    <FiSearch />
                </span>
            )}
            {showSearchSuggestions && (isSearchLoading || searchSuggestions.length > 0) && (
                <div className={style.searchAutofill}>
                    {isSearchLoading && (
                        <div className={style.searchLoadingItem}>Se încarcă...</div>
                    )}
                    {searchSuggestions.map((suggestion, index) => (
                        <button
                            key={suggestion.id}
                            type="button"
                            ref={(element) => {
                                suggestionRef(index, element);
                            }}
                            className={classnames(
                                style.searchSuggestionItem,
                                highlightedSuggestionIndex === index && style.searchSuggestionItemActive
                            )}
                            onMouseDown={(event) => event.preventDefault()}
                            onMouseEnter={() => onSuggestionMouseEnter(index)}
                            onClick={() => onSuggestionSelect(suggestion)}
                        >
                            {suggestion.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MapSearchBar;
